import { useMemo } from 'react';
import { useColumns, useStandardizedVariables } from '../stores/data';
import type { DataType } from '../utils/internal_types';

export interface ColumnMetadataSummary {
  id: string;
  name: string;
  dataType: DataType | null;
  isCollection: boolean;
}

/**
 * Returns metadata summaries for a list of column IDs.
 */
export function useColumnsMetadata(columnIds: string[]): Record<string, ColumnMetadataSummary> {
  const columns = useColumns();
  const standardizedVariables = useStandardizedVariables();

  return useMemo(() => {
    const metadata: Record<string, ColumnMetadataSummary> = {};

    columnIds.forEach((columnId) => {
      const column = columns[columnId];
      if (column) {
        const standardizedVariableId = column.standardizedVariable ?? null;
        const isCollection = standardizedVariableId
          ? Boolean(standardizedVariables[standardizedVariableId]?.is_multi_column_measure)
          : false;

        metadata[columnId] = {
          id: columnId,
          name: column.name ?? columnId,
          dataType: column.dataType ?? null,
          isCollection,
        };
      }
    });

    return metadata;
  }, [columns, columnIds, standardizedVariables]);
}

export default useColumnsMetadata;
